import { WishlistItem } from '../@types/woocommerce';

const normalizeWishlistItem = ({ product_id, item_id }: WishlistItem) => ({
  productId: product_id,
  itemId: item_id,
});

export default normalizeWishlistItem;
